import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./Auth";
import React, { ReactNode, useEffect, useState } from "react";

interface RequireAuthProps {
  children: ReactNode;
}

export const RequireAuth = ({ children }: RequireAuthProps) => {
  const location = useLocation();
  const auth = useAuth();

  const [refreshResult, setRefreshResult] = useState<boolean | null>(null);

  useEffect(() => {
    const refresh = async () => {
      const result = await auth.tryRefresh();
      setRefreshResult(result);
    };
    refresh();
  }, []);

  if (refreshResult === null) {
    // Still waiting for the refresh result
    return null;
  }

  if (!refreshResult) {
    //redirecting to login
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }
  return <>{children}</>;
};